import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';

import {
  AwsApiGwInterceptor,
  ClientNativeBridgeService,
  FormPostService,
  StateTransferService,
  WINDOW_PROVIDERS,
  WithCredentialsInterceptor,
} from '@fcom/core';
import { ConfigService } from '@fcom/core/services/config/config.service';
import { CookieService } from '@fcom/core/services/cookie/cookie.service';
import { GeolocationService } from '@fcom/core/services/geolocation/geolocation.service';
import { LocationRouteCffService } from '@fcom/core/services/location-routecff/location-routecff.service';
import { NativeBridgeService } from '@fcom/core/services/native-bridge/native-bridge.service';
import { TimeAndGeoipProvider } from '@fcom/core/services/time/time-geoip.provider';
import { TimeService } from '@fcom/core/services/time/time.service';
import { CmsLocalizationProvider } from '@fcom/core/services/language/cms-localization.provider';
import { LocalizationProvider } from '@fcom/core/services/language/localization.provider';
import { DataCloudService } from '@fcom/common/datacloud/services/datacloud.service';
import { GtmService } from '@fcom/common/gtm/services/gtm.service';
import { LoginTokenInterceptor } from '@fcom/common/login/interceptors/login-token.interceptor';
import { DatadogHeadersInterceptor } from '@fcom/common/interceptors/datadog-headers.interceptor';
import { BreadcrumbService } from '@fcom/common/services/breadcrumb/breadcrumb.service';
import { CommonAirBoundsService } from '@fcom/common/services/common-air-bounds/common-air-bounds.service';
import { CommonInstantSearchService } from '@fcom/common/services/common-instantsearch/common-instantsearch.service';
import { HotjarService } from '@fcom/common/services/hotjar/hotjar.service';
import { NavigatedPathToContentWrapperService } from '@fcom/common/services/navigated-path-to-content-wrapper/navigated-path-to-content-wrapper.service';
import { NavigationMenuService } from '@fcom/common/services/navigation-menu/navigation-menu.service';
import { PageMetaService } from '@fcom/common/services/page-meta/page-meta.service';
import { PriceCalendarService } from '@fcom/common/services/price-calendar/price-calendar.service';
import { SchemaService } from '@fcom/common/services/schema/schema.service';
import { ScrollService } from '@fcom/common/services/scroll/scroll.service';
import { DapiUatInterceptor } from '@fcom/core/interceptors/dapi-uat-interceptor';
import { CryptoChallengeInterceptor } from '@fcom/core/interceptors/crypto-challenge.interceptor';
import { CampaignBannerService } from '@fcom/common/services/campaign-banner/campaign-banner.service';
import { FeedbackService } from '@fcom/common/services/feedback/feedback.service';
import { DapiHeadersInterceptor } from '@fcom/core/interceptors/dapi-headers-interceptor';
import { TierBenefitService } from '@fcom/core/services/tier-benefit/tier-benefit.service';

import { ClientDataCloudService } from '../services/client-datacloud.service';
import { ClientGtmService } from '../services/client-gtm.service';

export const INTERCEPTOR_PROVIDERS: Provider[] = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AwsApiGwInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: WithCredentialsInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LoginTokenInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: DapiUatInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: DapiHeadersInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CryptoChallengeInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: DatadogHeadersInterceptor,
    multi: true,
  },
];

export const WEB_SERVICE_PROVIDERS: Provider[] = [
  CookieService,
  GeolocationService,
  ScrollService,
  TimeAndGeoipProvider,
  TimeService,
  { provide: DataCloudService, useClass: ClientDataCloudService },
  { provide: GtmService, useClass: ClientGtmService },
  ...WINDOW_PROVIDERS,
];

export const COMMON_SERVICE_PROVIDERS: Provider[] = [
  ConfigService,
  TierBenefitService,
  FormPostService,
  LocationRouteCffService,
  { provide: NativeBridgeService, useClass: ClientNativeBridgeService },
  NavigationMenuService,
  PageMetaService,
  StateTransferService,
  BreadcrumbService,
  NavigatedPathToContentWrapperService,
  { provide: LocalizationProvider, useClass: CmsLocalizationProvider },
  CampaignBannerService,
  FeedbackService,
  HotjarService,
  SchemaService,
  PriceCalendarService,
  CommonAirBoundsService,
  CommonInstantSearchService,
];
